import AccountConfirmation from './containers/AccountConfirmationContainer'

export default {
  path: '/account-confirmation/',
  component: AccountConfirmation
}



// WEBPACK FOOTER //
// ./src/routes/accountConfirmation/blankUid.js